import { Reveal, Chapter } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";
import { Check, Minus } from "lucide-react";

const TIERS = ["Standard Placement", "Pre-Opening Plan", "Full Advisory"];

const ROWS = [
  { label: "Bespoke Talent Sourcing", tiers: [1, 1, 1] },
  { label: "Candidate Screening", tiers: [1, 1, 1] },
  { label: "Executive Search", tiers: [1, 1, 1] },
  { label: "Pre-Opening Recruitment Strategy", tiers: [0, 1, 1] },
  { label: "SOP & Training Manual Development", tiers: [0, 1, 1] },
  { label: "Operational Auditing & Review", tiers: [0, 0, 1] },
  { label: "Labor Structure Review", tiers: [0, 0, 1] },
  { label: "Training & Development", tiers: [0, 1, 1] },
  { label: "Monthly HR & Procurement Reporting", tiers: [0, 0, 1] },
];

const Tiers = () => (
  <section data-testid="tiers-section" className="bg-ivory py-28 lg:py-40 hairline">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <Reveal>
        <Chapter number="08" label="Service Tiers" />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08] text-ink mb-16 lg:mb-24">
          Strategic Service <span className="italic text-bronze">Solutions</span>
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="overflow-x-auto" data-testid="tiers-table">
          <table className="w-full min-w-[720px] border-collapse">
            <thead>
              <tr className="border-b border-ink">
                <th className="text-left py-6 pr-6 w-2/5" />
                {TIERS.map((t, i) => (
                  <th key={t} className="py-6 px-4 text-center">
                    <span className="block text-[9px] tracking-[0.3em] uppercase text-bronze mb-2">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-serif text-xl lg:text-2xl font-light text-ink">{t}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r) => (
                <tr
                  key={r.label}
                  data-testid={`tier-row-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="border-b border-ink/10 hover:bg-sand/40 transition-colors duration-500"
                >
                  <td className="py-5 pr-6 text-sm text-ink/75">{r.label}</td>
                  {r.tiers.map((v, i) => (
                    <td key={i} className="py-5 px-4 text-center">
                      {v ? (
                        <Check size={16} className="inline text-bronze" strokeWidth={1.5} />
                      ) : (
                        <Minus size={16} className="inline text-ink/20" strokeWidth={1.5} />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <button
          data-testid="tiers-cta-proposal"
          onClick={() => scrollToId("#contact")}
          className="mt-14 text-[11px] tracking-[0.25em] uppercase px-8 py-4 bg-ink text-ivory hover:bg-bronze hover:text-ink transition-colors duration-500"
        >
          Request a Proposal
        </button>
      </Reveal>
    </div>
  </section>
);

export default Tiers;
